import {createAction} from 'web-app/util/redux/famly-app-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type Surcharge} from './model';

const domain = 'ENTITIES/SURCHARGES';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    (institutionId: string, billPayerId: string) => ({institutionId, billPayerId}),
    (institutionId: string, billPayerId: string, surcharges: Surcharge[], behaviors: BehaviorsCollection) => ({
        institutionId,
        billPayerId,
        surcharges,
        behaviors,
    }),
);

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(
    `${domain}/CREATE`,
    (institutionId: string, billPayerId: string, surcharge: Surcharge) => ({institutionId, billPayerId, surcharge}),
    (institutionId: string, billPayerId: string, surcharge: Surcharge) => ({institutionId, billPayerId, surcharge}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (institutionId: string, surcharge: Surcharge) => ({institutionId, surcharge}),
    (surcharge: Surcharge) => ({surcharge}),
);

export const {
    action: deleteSurcharge,
    success: deleteSurchargeSuccess,
    failed: deleteSurchargeFailed,
    aborted: deleteSurchargeAborted,
} = createAction(
    `${domain}/DELETE`,
    (institutionId: string, surcharge: Surcharge) => ({institutionId, surcharge}),
    (surchargeId: string, billPayerId: string) => ({surchargeId, billPayerId}),
);
